<template>
  <div ref="FNb_SalesReceipt" class="d-none">
    <div v-html="EjsData"></div>
    <!-- <table style="width:100%;max-width: 320px; font-size: 12px;">
      <thead>
        <tr>
          <th colspan="5" style="text-align: center;">
            <p style="margin:0;font-weight:bold">{{ cinemadetails[0].cine_name }}</p>
            <p style="margin:3px;">{{ cinemadetails[0].cine_phone }}</p>
          </th>
        </tr>

        <tr>
          <th colspan="2" style="text-align:left;">
            <p style="font-size: 10px;margin:0;">Sales Receipt</p>
            <span>{{ currentDate }}</span>
          </th>
          <th colspan="3" style="text-align:right;">
            <p style="font-size: 10px;margin:0;">Order No:</p>
            <span>{{ getOrderId }}</span>
          </th>
        </tr>

        <tr>
          <td colspan="5" style="padding-top:10px;border-bottom:1px dashed #404040;"></td>
        </tr>

        <tr>
          <th style="width: 45%;text-align:left;">DESCRIPTION</th>
          <th style="width 10%;text-align:center;">QTY</th>
          <th style="width: 15%;text-align:center;">PRICE</th>
          <th style="width: 15%;text-align:center;">TAX</th>
          <th style="width: 15%;text-align:right;">TOTAL</th>
        </tr>

        <tr>
          <td colspan="5" style="border-top:1px dashed #404040;"></td>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td colspan="5">
            <p style="margin:15px 0 5px 0;font-size:10px;color:#484848;">CONCESSION:</p>
          </td>
        </tr>

        <tr v-for="(item, itemIndex) in Items" :key="itemIndex">
          <td>{{ item.item_name || '-' }}</td>
          <td>{{ item.quantity }}</td>
          <td v-if="PickupFnb == true">{{ item.fp_amount.toFixed(this.MIN_FRACTION_DIGITS) }}</td>
          <td v-else>{{ item.fp_amount.toFixed(this.MIN_FRACTION_DIGITS) * item.quantity}}</td>
          <td v-if="PickupFnb == true">
            <span>{{ item.additionalTaxes.reduce(function(accumulator, x) { if(item.item_id == x.item_id) return accumulator += x.totalTax; }, 0).toFixed(this.MIN_FRACTION_DIGITS) }}</span>
          </td>
          <td v-else>
            <span>{{ Taxes.reduce(function(accumulator, x) { if(item.item_id == x.item_id) return accumulator += x.totalTax; }, 0).toFixed(this.MIN_FRACTION_DIGITS) }}</span>
          </td>
          <td
            v-if="PickupFnb == true"
          >{{ (item.additionalTaxes.reduce(function(accumulator, x) { if(item.item_id == x.item_id) return accumulator += x.totalTax; }, 0) + item.fp_amount).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
          <td
            v-else
          >{{ (Taxes.reduce(function(accumulator, x) { if(item.item_id == x.item_id) return accumulator += x.totalTax; }, 0) + item.fp_amount * item.quantity).toFixed(this.MIN_FRACTION_DIGITS) }}</td>
        </tr>

        <tr>
          <td colspan="5" style="padding-top: 3px;border-bottom:1px dashed #404040;"></td>
        </tr>

        <tr>
          <td colspan="2" style="text-align:left;">
            <p style="margin: 2px 0;font-weight: bold;">Concession Total:</p>
          </td>

          <td colspan="3" style="text-align: right;">
            <p
              style="margin: 2px 0;font-weight: bold;"
            >{{ Currency }} {{ FnBItemsTotalPrice.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
          </td>
        </tr>

        <tr
          v-if="getSelectedOffer && getSelectedOffer.offer_print_on_ticket == 'Y' || offerFor == 'vouchers'"
        >
          <td colspan="2" style="text-align: left;">
            <div style="font-weight: bold;">Discount</div>
            {{ getSelectedOffer.offer_title || getSelectedOffer.voucher_title }}
          </td>
          <td
            colspan="3"
            style="text-align: right; vertical-align: bottom"
          >{{ Currency }} {{ offerPrice }}</td>
        </tr>

        <tr>
          <td colspan="5" style="padding-top: 15px;border-bottom:1px dashed #404040;"></td>
        </tr>

        <tr>
          <td colspan="1" style="text-align:left;font-weight:bold;">NET PRICE</td>
          <td colspan="2" style="text-align:center;font-weight:bold;">TAX</td>
          <td colspan="2" style="text-align:right;font-weight:bold;">AMOUNT</td>
        </tr>

        <tr>
          <td colspan="5" style="border-top:1px dashed #404040;"></td>
        </tr>

        <tr>
          <td colspan="1" style="text-align:left;">
            <p style="margin: 2px  0;">{{ FnbNetAmount.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
          </td>
          <td colspan="2" style="text-align:center;"></td>
          <td colspan="2" style="text-align:right;">
            <p style="margin:2px 0;">{{ Currency }} {{ FnBItemsTotalPrice.toFixed(this.MIN_FRACTION_DIGITS) }}</p>
          </td>
        </tr>

        <tr>
          <td colspan="5">
            <p style="margin: 15px 0 0 0;;">Sold By: {{ name }}</p>
            <p
              style="margin: 3px 0;"
            >Sold on: {{ hardwarename && hardwarename.length > 0 ? hardwarename : '-' }}</p>
          </td>
        </tr>
      </tbody>
    </table>-->
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import moment from "moment";
import { EventBus } from "@/main";
import PosFnbService from "@/services/PosFnbService";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      currentDate: "",
      TaxAmountValue: "",
      name: "",
      pos_hardware_name: "",
      rebateTax: null,
      EjsData: null,
      user_id: null
    };
  },
  props: {
    printText: {
      type: String,
      default: "Print"
    },
    onClickHandler: {
      type: Function
    },
    itemsList: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      default: ""
    },
    subTotal: {
      type: Number,
      default: null
    },
    total: {
      type: Number,
      default: null
    },
    taxes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taxesTotal: {
      type: Number,
      default: null
    },
    onNumberSubmit: {
      type: Function
    },
    onPrintCall: {
      type: Function
    }
  },
  computed: {
    CinemaName() {
      return (
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").cine_name
      );
    },
    cinemadetails() {
      return this.$store.getters.cinemadetails;
    },
    Currency() {
      return this.currency;
    },
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
    offerFor() {
      return this.$store.getters.getOfferFor;
    },
    getSelectedOffer() {
      return this.$store.getters.getSelectedOffer;
      toString;
    },
    offerPrice() {
      return this.getOfferPrice ? parseFloat(this.getOfferPrice) : 0;
    },
    paymentDetails() {
      return this.$store.getters.selectedPaymentMode;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    Items() {
      return this.itemsList;
    },
    PickupFnb() {
      return this.itemsList[0].PickupFnb ? true : false;
    },
    SubTotal() {
      return this.subTotal ? this.subTotal : null;
    },
    Total() {
      return this.subTotal !== null && this.taxesTotal !== null
        ? this.subTotal + this.taxesTotal
        : null;
    },
    Taxes() {
      console.log("this.taxes :>> ", this.taxes);
      return this.taxes;
    },
    TaxesTotal() {
      console.log("this.taxesTotal :>> ", this.taxesTotal);
      return this.taxesTotal ? this.taxesTotal : null;
    },
    getSelectedArray() {
      let array = [];
      if (
        this.bookingDetails &&
        this.bookingDetails["seats_types"] &&
        this.bookingDetails["seats_types"].length > 0
      ) {
        this.bookingDetails.seats_types.map(x => {
          x.seats.map(y => {
            array.push({
              seatName: y,
              seatType: x.seat_type
            });
          });
        });
      }
      return array;
    },
    getTaxesNames() {
      let taxName = [];
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          taxName.push(e.charge_type_name);
        });
        return taxName.toString();
      } else {
        return "No Charges";
      }
    },
    getTaxAmount() {
      let TaxValue = null;

      console.log("this.AdditionalCharges :", this.AdditionalCharges);
      if (this.AdditionalCharges && this.AdditionalCharges.length > 0) {
        this.AdditionalCharges.forEach(e => {
          TaxValue += e.sp_value;
        });
        return TaxValue;
      } else {
        return (TaxValue = 0.0);
      }
    },
    getTotal() {
      let Total = null;

      Total = this.netAmount + this.getTaxAmount;
      return Total;
    },
    totalAmount() {
      return this.getOfferPrice > 0
        ? this.$store.getters.TOTAL_AMOUNT - this.getOfferPrice
        : this.$store.getters.TOTAL_AMOUNT;
    },
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
    getTotalFnBTax() {
      let taxes = null;

      if (this.Taxes && this.Taxes.length > 0) {
        this.Taxes.forEach(e => {
          if (e.pas_is_rebate == "N") {
            taxes += e.totalTax;
          } else {
            this.rebateTax = e.totalTax;
          }
        });

        // rebateTax != null ? taxes - rebateTax : taxes;
        return taxes;
      } else {
        return (taxes = 0.0);
      }
    },
    FnbNetAmount() {
      let fnbamount = null;

      if (this.Items && this.Items.length > 0) {
        this.Items.forEach(e => {
          if (e.PickupFnb) {
            fnbamount += e.fp_amount;
          } else {
            fnbamount += e.fp_amount * e.quantity;
          }
        });
        return fnbamount;
      } else {
        return (fnbamount = 0.0);
      }
    },
    tickettotal() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    hardwarename() {
      return this.$store.getters.gethardwarename;
    },
    ...mapGetters(["getOfferPrice", "getSelectedOffer", "getOfferFor"]),
    ...mapState({
      FnBItemsTotalPrice: state =>
        this.rebateTax != null
          ? state.FnBStore.selectedFnBItemsTotalPrice +
            state.FnBStore.totalAdditionalTaxes -
            this.rebateTax
          : state.FnBStore.selectedFnBItemsTotalPrice +
            state.FnBStore.totalAdditionalTaxes
    })
  },
  beforeMount() {
    this.currentDate = moment().format("DD/MM/YY HH:mm");
    const { cinema_id } = this.secureStore.get("USINFO");
    this.name = this.secureStore.get("USINFO").first_name;
  },
  mounted() {
    this.user_id = this.secureStore.get("USINFO").user_id;

    EventBus.$on("printFnbSalesReceipt", () => {
      // this.print();
      console.log("coming fnb eventbus:>> ");
      this.GetEjs();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printFnbSalesReceipt");
  },
  methods: {
    GetEjs: function() {
      let payload = {
        OrderCode: this.getOrderId,
        Type: "PrintReceipt",
        UserID: this.user_id
      };
      let loader = this.$loading.show();

      PosFnbService.GetFnbOrderEjs(payload)
        .then(async response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });

          // console.log("response :>> ", response);
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.FNb_SalesReceipt) {
        p.print(this.$refs.FNb_SalesReceipt, []);
      }
    }
  }
};
</script>

<style>
table,
td,
th {
  padding: 8px;
}
</style>
 





// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/ReceiptTemplates/fnb_sales_receipts.vue